import React from 'react';
import {CallbackComponent} from "redux-oidc";
import {loadUser} from 'redux-oidc';
import {withRouter} from 'react-router-dom';
import userManager from "../../userManager";

const Login = props => {

  return (
    <CallbackComponent
      userManager={userManager}
      successCallback={() => {
        loadUser(props.store, userManager);
        props.history.push('/');
      }}
      errorCallback={error => {
        props.history.push('/');
      }}
    >
      <div>Logging in...</div>
    </CallbackComponent>
  );
};

export default withRouter(props => <Login {...props}/>);
